export default [
  '/',
  '/contacts',
  '/press-center',
  '/about/processing-of-personal-data',
  '/about/investor-relations',
  '/about/sootvetstvie-pci-dss',
  '/cards-mir/terms-and-tariffs',
];
